import React, { useEffect } from "react";
import "./LoadingIndicator.scss";
import { useTypedDispatch, useTypedSelector } from "hooks/store";
import { hideLoading, resetLoading } from "state/slices/LoadingIndicatorSlice";
import { dataEvents } from "Classes/Events";

const LoadingIndicator: React.FC = () => {
    const dispatch = useTypedDispatch();
    const isLoading = useTypedSelector((store) => store.Loading.isLoading);
    const isTimeout = useTypedSelector((store) => store.Loading.isTimeout);

    useEffect(() => {
        dataEvents.on("dataLoaded", () => {
            dispatch(hideLoading());
        });
        return () => {
            dispatch(resetLoading());
        };
    }, []);

    if (isTimeout) {
        return null;
    }

    return (
        <section className={`loadingWrapper ${isLoading ? "hideLoading" : ""}`}>
            <div className="loadingContainer">
                <h5>Loading...</h5>
                <div className="snippet" data-title=".dot-pulse">
                    <div className="stage">
                        <div className="dot-pulse" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LoadingIndicator;
